module.exports = __webpack_public_path__ + "static/media/DSC00523-27_Small.6a1dc03a.jpg";